export const SPECIALIZATIONS = [
  'Alergologie și imunologie clinică',
  'Anestezie și terapie intensivă',
  'Boli infecțioase',
  'Cardiologie',
  'Dermato-venerologie',
  'Diabet zaharat, nutriție și boli metabolice',
  'Endocrinologie',
  'Gastroenterologie',
  'Geriatrie și gerontologie',
  'Medicină de familie',
  'Medicină de urgență',
  'Medicină internă',
  'Medicină generală',
  'Medicina muncii',
  'Medicină sportivă',
  'Nefrologie',
  'Neonatologie',
  'Neurologie',
  'Neurologie pediatrică',
  'Oncologie medicală',
  'Pediatrie',
  'Pneumologie',
  'Psihiatrie',
  'Neuropsihiatrie infantilă (NPI)',
  'Recuperare, medicină fizică și balneologie (BFT)',
  'Reumatologie',
  'Neurochirurgie',
  'Obstetrică-ginecologie',
  'Oftalmologie',
  'Ortopedie și traumatologie',
  'O.R.L.',
  'Urologie',
  'Nutriție și dietetică',
];
